module.exports = __webpack_public_path__ + "static/images/skinbg.8c2a67b.png";